import isStrongPassword from 'validator/es/lib/isStrongPassword';

export default (value: string): boolean => isStrongPassword(value, { minLength: 8, minLowercase: 1, minUppercase: 1, minNumbers: 1, minSymbols: 1 });
